import { apiUrl4, apiUrl2, apiUrl1 } from "../configs/constant";

export const postClockInPayment = async (data) => {
  const url = `${apiUrl4}/clockin/payment`;

  let response  = await fetch(url, {
    method: 'POST', 
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })

  return await response.json();
}

export const updateClockInTxId = async (data) => {
  const url = `${apiUrl4}/clockin/payment/updateTxId`;

  let response  = await fetch(url, {
    method: 'POST', 
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })

  return await response.json();
}

export const bumpClockInPayment = async (data) => {
  const url = `${apiUrl4}/clockin/bumpFee`;

  let response  = await fetch(url, {
    method: 'POST', 
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })

  return await response.json();
}

export const getClockInPayment = async (address, block) => {
  const url = `${apiUrl4}/clockin/payment?address=${address}&block=${block}`;

  let response  = await fetch(url, {
    method: 'GET', 
    headers: {
      'Content-Type': 'application/json',
    }
  })

  return await response.json();
}

export const getPaymentUtxosAlkanesMerge = async (data) => {
  
  const url = `${apiUrl1}/getPaymentUtxosAlkanesMerge`;

  let response  = await fetch(url, {
    method: 'POST', 
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })

  return await response.json();
}

export const registerAlkanesLoyalty = async (address, amount) => {
  const url = `${apiUrl4}/alkanes/loyalty/register`;

  let response  = await fetch(url, {
    method: 'POST', 
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({address, amount}),
  })

  return await response.json();
}

export const getAlkanesLoyalty = async (address) => {
  const url = `${apiUrl4}/alkanes/loyalty?address=${address}`;

  let response  = await fetch(url, {
    method: 'GET', 
    headers: {
      'Content-Type': 'application/json',
    }
  })

  return await response.json();
}

export const getPaymentUtxosForClockIn = async (data) => {
  
  const url = `${apiUrl1}/getPaymentUtxosForClockIn`;

  let response  = await fetch(url, {
    method: 'POST', 
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })

  return await response.json();
}

export const getPaymentUtxosForClockInForReserve = async (data) => {
  
  const url = `${apiUrl1}/getPaymentUtxosForClockInForReserve`;

  let response  = await fetch(url, {
    method: 'POST', 
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })

  return await response.json();
}

export const getAlkanesAddressOutput = async (address, name = "") => {
  const url = `${apiUrl4}/alkanes/address/output?address=${address}&name=${name}`;

  let response  = await fetch(url, {
    method: 'GET', 
    headers: {
      'Content-Type': 'application/json',
    }
  })

  return await response.json();
}

export const getAlkanesTopMint = async (data) => {
  const url = `${apiUrl4}/alkanes/mint/top`;

  let response  = await fetch(url, {
    method: 'POST', 
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data)
  })

  return await response.json();
}

export const getAlkanesBalance = async (data) => {
  const url = `${apiUrl4}/alkanes/balance`;

  let response  = await fetch(url, {
    method: 'POST', 
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data)
  })

  return await response.json();
}


export const getAlkanesKey = async (block, tx) => {
  const url = `${apiUrl2}/alkanes/generateKey?block=${block}&tx=${tx}`;

  let response  = await fetch(url, {
    method: 'GET', 
    headers: {
      'Content-Type': 'application/json',
    }
  })

  return await response.json();
}

export const mintAlkanesStart = async (randomKey, transactionDatas) => {
  
  const url = `${apiUrl4}/alkanes/mint/start`;
  const data = {
    randomKey : randomKey,
    transactionDatas : transactionDatas
  };

  let response  = await fetch(url, {
    method: 'POST', 
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })

  return await response.json();
}

export const mintAlkanesCancel = async (randomKey) => {
  
  const url = `${apiUrl4}/alkanes/mint/cancel`;
  const data = {
    randomKey : randomKey
  };

  let response  = await fetch(url, {
    method: 'POST', 
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })

  return await response.json();
}

export const mintAlkanesFunded = async (randomKey) => {
  
  const url = `${apiUrl4}/alkanes/mint/fund`;
  const data = {
    randomKey : randomKey
  };

  let response  = await fetch(url, {
    method: 'POST', 
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })

  return await response.json();
}

export const mintAlkanesPrepare = async (runeKey, newRuneKey, count, receiveAddress, outputValue, feeRate) => {
  
  const url = `${apiUrl4}/alkanes/mint/prepare`;
  const data = {
    runeKey : runeKey,
    newRuneKey : newRuneKey,
    count : count,
    receiveAddress : receiveAddress,
    outputValue : outputValue,
    feeRate : feeRate
  };

  let response  = await fetch(url, {
    method: 'POST', 
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })

  return await response.json();
}